import React from "react"
import {
  Container,
} from 'design-react-kit';

export const SibaTitoloPagina = ({titolo}) => {

  return (
    <Container className="px-3 my-3" id="titolo" tag="div">
      {
        titolo ? (<h1>{titolo}</h1>) : (null)
      }
    </Container>
  );
}

export default SibaTitoloPagina;